import {Component, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {BaseModalComponent} from '../base-modal.component';

@Component({
    selector: 'bb-select-modifiers',
    templateUrl: './select-modifiers.component.html',
    styleUrls: ['./select-modifiers.component.scss'],
})
export class SelectModifiersComponent extends BaseModalComponent implements OnInit {

    constructor(modalController: ModalController) {
        super(modalController);
    }

    ngOnInit() {
    }

}
